"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./index53.js"),o=require("./index113.js");var s=e.global,a=o.classofRaw,r=a(s.process)==="process";exports.engineIsNode=r;
